import { StarIcon } from "lucide-react";
import React from "react";
import { Badge } from "../../../../components/ui/badge";
import { Card, CardContent } from "../../../../components/ui/card";

// Testimonial data for mapping
const testimonials = [
  {
    id: 1,
    rating: 5,
    text: "The Sky Joy™ Kit made our Goa flight a breeze! My 6-year-old was completely absorbed in the storytelling cards and origami. It`s rare to see something both educational and fun like this. Plus, no screen tantrums—what a relief!",
    author: "Ankita Joshi",
    location: "India, Mumbai",
    profileImage: "/profile-1.png",
  },
  {
    id: 2,
    rating: 4,
    text: "Loved the concept behind the Jai Pavan™ Kit. My twins enjoyed the bilingual puzzles, especially in Hindi. It's a great way to keep kids connected to Indian culture while traveling. A small improvement in packaging durability would make it even better." ,
    author: "Manoj Reddy",
    location: "India, Hyderabad",
  },
  {
    id: 3,
    rating: 4,
    text: "Brilliant initiative! The Sky Joy™ Kit is the only reason my son didn`t keep asking `Are we there yet?` on our flight to Delhi. He particularly loved the magnetic games and storytelling prompts. Highly recommended for travel-loving families.",
    author: "Rajeev Nair",
    location: " India, Thiruvananthapuram",
  },
  {
    id: 4,
    rating: 3,
    text: "The activities are really good, and my daughter liked the coloring sheets. But we found some instructions a bit confusing without adult help. Still, it`s a refreshing idea for Indian train journeys where screens aren`t always reliable.",
    author: "Neha Sinha",
    location: "India, Patna",
  },
  {
    id: 5,
    rating: 5,
    text: "We used the Little Monsters Travel Kit during our Shimla trip. Very thoughtfully made! The eco-friendly aspect is a big plus for us. Would be awesome if future kits included content in regional languages like Marathi or Gujarati too.",
    author: "Pooja Bhandari",
    location: "India, Indore",
  },
  {
    id: 6,
    rating: 5,
    text: "Creative, fun, and definitely a boredom-buster for our kids during a 12-hour train journey. Jai Pavan™ Kit had enough variety to keep both my kids engaged. Just wish there was an option to reorder individual activity sheets once they`re used.",
    author: "Tanishq Varma",
    location: "India, Lucknow",
  },
];

export const SectionComponentNodeByAnima = (): JSX.Element => {
  return (
    <section id="reviews" className="flex flex-col gap-16 px-4 md:px-16 py-16 w-full bg-white">
      <div className="flex flex-col items-center justify-center gap-8 w-full">
        <Badge variant="outline" className="inline-flex items-center border-[#169c79] text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-foreground px-4 py-2 rounded-[100px] border-[#169c79] opacity-[0.93]">
          <span className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-extrabold text-[#169c79] text-xs leading-[16.8px]">REVIEW</span>
        </Badge>
        <div className="flex flex-col items-center justify-center gap-4 w-full">
          <h2 className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-bold text-[#1a1a1a] text-[28px] md:text-[40px] leading-[42px] md:leading-[60px] text-center">Our happy clients say about us</h2>
          <p className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-center text-base leading-6">
            <span className="font-bold text-[#169c79]">2,157 </span>
            <span className="text-[#595959]">people have said how we have helped them</span>
          </p>
        </div>
      </div>
      <div className="hidden md:grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
        {testimonials.map((testimonial) => (
          <Card key={testimonial.id} className="text-card-foreground shadow bg-white rounded-xl border border-[#f2edfb}">
            <CardContent className="flex flex-col items-start gap-8 p-8">
              <div className="flex items-start gap-2.5">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <StarIcon key={i} className="w-[17.5px] h-[16.74px] text-yellow-400 fill-yellow-400" />
                ))}
              </div>
              <p className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-medium text-[#595959] text-base leading-6">
                {testimonial.text}
              </p>
              <div className="flex items-center gap-3 w-full">
                {/* <img className="w-12 h-12 object-cover rounded-full" alt="Profile" src={testimonial.profileImage} /> */}
                <div className="flex flex-col items-start gap-0.5 flex-1">
                  <div className="[font-family:'DM_Sans',Helvetica] font-medium text-[#5e5e5e] text-base leading-6">
                    {testimonial.author}
                  </div>
                  <div className="opacity-50 [font-family:'DM_Sans',Helvetica] font-normal text-[#5e5e5e] text-xs leading-[18px]">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      <div className="flex flex-col md:hidden items-center gap-6 w-full">
        {testimonials.slice(0, 2).map((testimonial) => (
          <Card key={testimonial.id} className="border bg-card text-card-foreground shadow w-full border-[#f2edfb] rounded-xl">
            <CardContent className="p-8 flex flex-col items-start gap-8">
              <div className="flex items-start gap-2.5">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <StarIcon key={i} className="w-[17.5px] h-[16.74px] fill-current text-yellow-400" />
                ))}
              </div>
              <p className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-medium text-[#595959] text-base leading-6">
                {testimonial.text}
              </p>
              <div className="flex items-center gap-3 w-full">
                {/* <img className="w-12 h-12 object-cover rounded-full" alt="Profile" src={testimonial.profileImage} /> */}
                <div className="flex flex-col items-start gap-0.5 flex-1">
                  <div className="[font-family:'DM_Sans',Helvetica] font-medium text-[#5e5e5e] text-base leading-6">
                    {testimonial.author}
                  </div>
                  <div className="opacity-50 [font-family:'DM_Sans',Helvetica] font-normal text-[#5e5e5e] text-xs leading-[18px]">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
        <div className="flex items-center justify-center gap-4">
          <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 border bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-9 w-9 p-4 rounded-xl border-[#169c79]" disabled>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-left w-4 h-4">
              <path d="m15 18-6-6 6-6"></path>
            </svg>
          </button>
          <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 text-primary-foreground shadow hover:bg-primary/90 h-9 w-9 p-4 rounded-xl bg-[#169c79]">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-right w-4 h-4 text-white">
              <path d="m9 18 6-6-6-6"></path>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};